import * as React from 'react';

import {GlossaryBookmarkIcon} from '../icon/svg/glossary-bookmark-icon';
import {useRefObserver} from '../utils/hooks/use-ref-observer';

import styles from './glossary-button.module.css';

type Props = {
    onClick: () => any;
    buttonText?: string;
    isExpanded?: boolean;
};

export function GlossaryButton(props: Props) {
    const {isExpanded} = props;

    const buttonRef = React.useRef(null);

    const {isHovered} = useRefObserver(buttonRef, ['isHovered']);
    const [buttonState, setButtonState] = React.useState<'closed' | 'expanded' | 'closing'>(
        'closed'
    );

    React.useEffect(() => {
        if (isExpanded || isHovered) {
            setButtonState('expanded');
        } else if (!isExpanded && !isHovered && buttonState === 'expanded') {
            setButtonState('closing');
            setTimeout(
                () => {
                    setButtonState('closed');
                },
                // This is 100ms shorter than the transition duration in the CSS to avoid jumpiness
                900
            );
        }
    }, [isExpanded, isHovered, buttonState]);

    let buttonStyleName = styles['button-text--closed'];
    if (buttonState === 'expanded') {
        buttonStyleName = styles['button-text--expand'];
    } else if (buttonState === 'closing') {
        buttonStyleName = styles['button-text--closing'];
    }

    return (
        <button ref={buttonRef} onClick={props.onClick} className={styles['glossary-button']}>
            <div className={styles['icon-wrapper']}>
                <div className={styles['glossary-icon-container']}>
                    <GlossaryBookmarkIcon size={14} />
                </div>
            </div>
            <div className={buttonStyleName}>
                <div>{props.buttonText || 'Learn more'}</div>
            </div>
        </button>
    );
}
